import { render, staticRenderFns } from "./statement_list.vue?vue&type=template&id=107a98ae&scoped=true&"
import script from "./statement_list.vue?vue&type=script&lang=js&"
export * from "./statement_list.vue?vue&type=script&lang=js&"
import style0 from "./statement_list.vue?vue&type=style&index=0&id=107a98ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107a98ae",
  null
  
)

export default component.exports